import gql from 'graphql-tag';

const CREATE_ACCOUNT = gql`
  mutation createAccount($params: UserCreateInput!){
    createAccount(params: $params)
  }
`;

export default CREATE_ACCOUNT;



// WEBPACK FOOTER //
// ./src/graphql/mutations/createAccount.mutation.js